import { CheckCircle2, Clock3, FileText, XCircle } from "lucide-react";

/**
 * Phase 24 — Unified status pill for every hours display.
 *
 * Colors follow the design guardrail: gray/blue/green/rose. Never invent
 * new statuses; unknown values render as `draft`.
 *
 * Props:
 *   - status: "draft" | "submitted" | "approved" | "rejected"
 *   - size:   "sm" | "md" (default "md")
 */
const CONFIG = {
  draft:     { label: "Draft",     cls: "bg-slate-100 text-slate-600",       Icon: FileText },
  submitted: { label: "Submitted", cls: "bg-blue-100 text-blue-700",         Icon: Clock3 },
  approved:  { label: "Approved",  cls: "bg-emerald-100 text-emerald-700",   Icon: CheckCircle2 },
  rejected:  { label: "Rejected",  cls: "bg-rose-100 text-rose-700",         Icon: XCircle },
};

export default function StatusPill({ status, size = "md" }) {
  const cfg = CONFIG[status] || CONFIG.draft;
  const iconSize = size === "sm" ? "h-3 w-3" : "h-3.5 w-3.5";
  const pad = size === "sm" ? "px-1.5 py-0.5 text-[10px]" : "px-2 py-0.5 text-xs";
  return (
    <span
      className={`inline-flex items-center gap-1 rounded-full font-medium ${cfg.cls} ${pad}`}
      data-testid="hours-status-pill"
      data-status={status || "draft"}
    >
      <cfg.Icon className={iconSize} strokeWidth={2.5} />
      {cfg.label}
    </span>
  );
}

export { CONFIG as STATUS_PILL_CONFIG };
